import {GamesSliderProps} from "../../contenful/types";
import {GameSliderItem, GameSliderItemProps} from "./GameSliderItem";
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/swiper-bundle.css';
import React, {useRef, useState} from "react";
import {useSelector} from "react-redux";
import {AppState} from "../../RootReducer";
import './styles/GameSlider.scss';
import SwiperCore, {Navigation, Pagination, Controller, Mousewheel} from 'swiper/core';
import {getContainer} from "../../ioc/IOCSetup";

SwiperCore.use([Navigation, Pagination, Controller, Mousewheel]);

interface Props {
    section: GamesSliderProps;
    mobile: boolean;
}

export const GamesSlider = (props: Props) => {
    const isMobile = useSelector((app: AppState) => app.settings.mobile) || false;
    const locale = getContainer().getSettingsService().getActiveLocale().code;
    const deviceType = isMobile ? 'mobile' : 'desktop'
    const slidesPerView = isMobile ? props.section.slidesPerViewMobile : props.section.slidesPerViewDesktop;

    const css = props.section.cssClassName ? `gameSlider ${props.section.cssClassName}` : `gameSlider`
    const iconUrl = props.section.titleIcon?.fields?.file?.url;
    const showTitleIcon = props.section.titleIcon && props.section.titleIcon?.fields && props.section.titleIcon?.fields?.file
    const swiperRef = useRef<SwiperCore | null>(null);

    // if view is 5.5, then we need to start from 6th slide
    const startIndex = Math.ceil(slidesPerView);
    const [fadeIndex, setFadeIndex] = useState<number>(startIndex);

    const handleNext = () => {
        if (swiperRef.current) {
            swiperRef.current.slideTo(swiperRef.current.activeIndex + props.section.swipeStepSizePerClick)
        }
    };

    const handlePrev = () => {
        if (swiperRef.current) {
            swiperRef.current.slideTo(swiperRef.current.activeIndex - props.section.swipeStepSizePerClick)
        }
    };

    const calculateAndSetFadeIndex = (index: number, slidesPerView: number) => {
        const newFadeIndex = Math.floor(slidesPerView + index) //5.5 + 0 -> 6
        setFadeIndex(newFadeIndex)
    }

    const makeShowAllPath = (path: string, locale: string) => {
        const pathWithoutSlash = path.replace(/^\/+/, '');
        return `/${locale}/${pathWithoutSlash}`;
    }

    const showAllPath = makeShowAllPath(props.section.showAllLink || '', locale)

    return (
        <div className={css}>
            <div className={`container`}>
                <div className="section-outer">
                    <div className="title-wrapper">
                        <div className={"title-text"}>
                            <h4 className="title">
                                {showTitleIcon && <img src={iconUrl} className="icon" alt={props.section.title}/>}
                                {props.section.title}
                            </h4>
                        </div>

                        <div className="panel-navigate">
                            <div className="show-all-wrapper">
                                {props.section.showAllLink &&
                                    <div className={'see-all'}>
                                        <a href={showAllPath}>Show all</a>
                                    </div>}
                            </div>
                            {!isMobile && <div className="">
                                <div className={`navigate-wrapper navigate-bottom d-flex`}>
                                    <button type="button" className="navigate-prev" onClick={handlePrev}>
                                        <svg className="icon icon-arrowLeft" viewBox="0 0 24 24" width="24px"
                                             height="24px">
                                            <title>Arrow Left</title>
                                            <path d="M0 0h24v24H0z" fill="none"></path>
                                            <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"></path>
                                        </svg>
                                    </button>

                                    <button type="button" className="navigate-next" onClick={handleNext}>
                                        <svg className="icon icon-arrowRight" viewBox="0 0 24 24" width="24px"
                                             height="24px">
                                            <title>Arrow Right</title>
                                            <path d="M0 0h24v24H0z" fill="none"></path>
                                            <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"></path>
                                        </svg>
                                    </button>
                                </div>
                            </div>}


                        </div>
                    </div>
                    <div className={`inner-section ${deviceType}`}>
                        <Swiper
                            mousewheel={{"forceToAxis": true}}
                            spaceBetween={10}
                            slidesPerView={slidesPerView}
                            onInit={(swiper) => calculateAndSetFadeIndex(swiper.activeIndex, slidesPerView)}
                            onSlideChange={(swiper) => calculateAndSetFadeIndex(swiper.activeIndex, slidesPerView)}
                            onSwiper={(swiper) => swiperRef.current = swiper}
                        >
                            {
                                props.section.gameSliderItems.map((gameItem, index) => {
                                    return (
                                        <SwiperSlide
                                            key={index}>
                                            <GameSliderItemWrapper gameItem={gameItem} listIndex={index}
                                                                   slidesPerView={slidesPerView}
                                                                   fadeIndex={fadeIndex}/>
                                        </SwiperSlide>
                                    )
                                })
                            }
                        </Swiper>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const GameSliderItemWrapper = (props: {
    gameItem: GameSliderItemProps,
    listIndex: number,
    slidesPerView: number,
    fadeIndex: number
}) => {
    const fade3 = props.listIndex >= props.fadeIndex ? 'fade' : '';
    return (
        <div className={`${fade3}`}>
            <GameSliderItem {...props.gameItem} />
        </div>
    )
}